var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8867 15.5093L13.1823 9.16342C13.0109 9.0841 12.8224 9.04885 12.6339 9.0609C12.4454 9.07295 12.2629 9.13191 12.103 9.23241C11.9432 9.33291 11.811 9.47176 11.7186 9.63632C11.6261 9.80088 11.5763 9.98592 11.5738 10.1746L11.5738 22.8608C11.5722 23.0545 11.6206 23.2453 11.7144 23.4148C11.8082 23.5843 11.9442 23.7268 12.1092 23.8285C12.2743 23.9302 12.4627 23.9876 12.6565 23.9952C12.8502 24.0028 13.0426 23.9604 13.2152 23.872L25.8867 17.5261C26.0744 17.432 26.2322 17.2876 26.3425 17.109C26.4528 16.9305 26.5112 16.7248 26.5112 16.515C26.5112 16.3052 26.4528 16.0995 26.3425 15.9209C26.2322 15.7423 26.0744 15.5979 25.8867 15.5038L25.8867 15.5093Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8691_1052",
    x1: 48.5419,
    y1: -3.53059,
    x2: -8.42193,
    y2: 62.1017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null)))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPlay);
export default __webpack_public_path__ + "static/media/buttonPlay.0f4e06a43fc4facab8edf3986a63abd3.svg";
export { ForwardRef as ReactComponent };